export default "__VITE_ASSET__CMZo8Cz$__"